import * as React from "react";
import {FormGroupProps} from "../../common/props/FormGroupProps";
import {PlaceholderProps} from "../../common/props/PlaceholderProps";
import {none, option} from "ts-option";
import User from "../../../model/user/User";
import FormGroup from "../../../hiberUiKit/src/molecules/FormGroup/FormGroup";
import BDPSelectorWrapper from "../v4/bdpSelector/BDPSelectorWrapper";

interface ComponentProps {
	/**
	 * Indicate if selection is removable (shows "x" button).
	 */
	removable?: boolean;
}

type Props = ComponentProps & FormGroupProps<string> & PlaceholderProps;

/**
 * Business Development Partner selector form view group.
 */
export default class BDPSelectorFormGroup extends React.PureComponent <Props, {}> {
	constructor(props: Props) {
		super(props);
		this.onChange = this.onChange.bind(this);
	}

	render() {
		return (
			<FormGroup label={this.props.label} error={this.props.field.firstError().getOrElse("")}>
				<div>
					<BDPSelectorWrapper businessDevelopmentPartnerId={this.props.field.getOptionalValue()}
									 onChange={this.onChange}
									 onRemoveClick={() => this.props.onChange(this.props.field.updateValue(none))}
									 removable={this.props.field.getOptionalValue().isDefined && this.props.removable}/>
				</div>
			</FormGroup>
		);
	}

	/**
	 * Callback on BDP changed.
	 * @param user
	 */
	onChange(user: User) {
		this.props.onChange(this.props.field.updateValue(option(user.id)));
	}
}
